import type { InboxItem } from '../../types/inbox';

/**
 * Phone number behind an SMS inbox item.
 *
 * SMS items are keyed by conversation: `sms-conversation-<E.164>` (see
 * build_sms_conversation_source_id in inbox/models.py).
 */
export const getSmsPhoneNumber = (item: InboxItem): string | null => {
  const prefix = 'sms-conversation-';
  if (item.channel !== 'sms' || !item.source_id?.startsWith(prefix)) return null;
  return item.source_id.slice(prefix.length).split("|").at(-1) || null;
};

/** CallLog id behind a call inbox item (`call-<id>`). */
export const getCallLogId = (item: InboxItem): number | null => {
  const prefix = 'call-';
  if (!item.source_id?.startsWith(prefix)) return null;
  const id = Number(item.source_id.slice(prefix.length));
  return Number.isFinite(id) ? id : null;
};

/** Local business number. Legacy combined conversations have no inferred sender. */
export const getSmsLocalNumber = (item: InboxItem): string | undefined => {
  if (item.channel !== 'sms' || !item.source_id?.startsWith('sms-conversation-')) return undefined;
  const parts = item.source_id.slice('sms-conversation-'.length).split('|');
  return parts.length === 2 ? parts[0] : undefined;
};
